import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPills24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconPills24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 11.5H3.5v1H6zM3.5 10A1.5 1.5 0 0 0 2 11.5v1A1.5 1.5 0 0 0 3.5 14H6a1.5 1.5 0 0 0 1.5-1.5v-1A1.5 1.5 0 0 0 6 10zm10 1.5h-3v1h3zm-3-1.5A1.5 1.5 0 0 0 9 11.5v1a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-1a1.5 1.5 0 0 0-1.5-1.5zm7.5 1.5h2.5v1H18zm-1.5 0A1.5 1.5 0 0 1 18 10h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5H18a1.5 1.5 0 0 1-1.5-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPills24);
